import { useObserver } from 'mobx-react-lite';
import { filter } from 'lodash';

import useCart from 'hooks/use-cart';

/**
 * POS-13717: Hook for detecting applied POS discounts with group/segment restrictions.
 *
 * This is SEPARATE from useAppliedOffers which only handles bundle/mix-and-match "offers".
 * POS sale discounts don't appear in the offers system because they don't require
 * buying multiple items or meeting bundle conditions.
 *
 * This hook gets restriction metadata directly from the price cart response,
 * which includes all applied discounts regardless of type.
 */
export default function useAppliedRestrictedDiscounts() {
  const cart = useCart();

  // Get all applied discounts with metadata from price cart response
  const appliedDiscountsWithMetadata = useObserver(() => cart.appliedDiscountsWithMetadata);

  // Filter to only restricted discounts (group or segment membership required)
  const restrictedDiscounts = useObserver(() => filter(appliedDiscountsWithMetadata, { isRestricted: true }));

  // Check if any restricted discount is applied
  const hasRestrictedDiscount = restrictedDiscounts.length > 0;

  return {
    restrictedDiscounts,
    hasRestrictedDiscount,
  };
}
